import * as React from "react";
import { Typography } from "@material-ui/core";

var ResultInformation = function ResultInformation(_a) {
  var quiz = _a.quiz,
      quizAnswer = _a.quizAnswer,
      generalLabels = _a.generalLabels;

  var hasCorrectAnswer = function hasCorrectAnswer(quiz) {
    return quiz.items.some(function (item) {
      return item.type === "essay" || item.type === "multiple-choice" || item.type === "open";
    });
  };

  var atLeastOneCorrect = function atLeastOneCorrect(itemAnswers) {
    return itemAnswers.some(function (ia) {
      return ia.correct === true;
    });
  };

  var types = quiz.items.map(function (item) {
    return item.type;
  });
  var feedback = undefined;

  if (!hasCorrectAnswer(quiz)) {
    feedback = generalLabels.alreadyAnsweredLabel;
  }

  if (feedback === undefined && !atLeastOneCorrect(quizAnswer.itemAnswers)) {
    feedback = types.includes("essay") || types.includes("scale") ? "" : generalLabels.answerIncorrectLabel;
  }

  var quizItems = quiz.items;
  var numberOfNotIncorrectAnswers = quizAnswer.itemAnswers.filter(function (ia) {
    if (ia.correct === true) return true;
    var item = quizItems.find(function (i) {
      return i.id === ia.quizItemId;
    });
    return item && (item.type === "checkbox" || item.type === "feedback" || item.type === "scale" || item.type === "research-agreement");
  }).length;

  if (feedback === undefined) {
    feedback = quiz.items.length === 1 ? generalLabels.answerCorrectLabel : generalLabels.kOutOfNCorrect(numberOfNotIncorrectAnswers, quiz.items.length);
  }

  return React.createElement(Typography, {
    variant: "h5"
  }, feedback);
};

export default ResultInformation;